/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import de from '../i18n/de.json'

const i18n = new VueI18n({
  locale: 'de', // set locale
  messages: {
    'de': de
  }
})


import Vue from 'vue'
import Booking from '../booking/index.vue'

import Sticky from 'vue-sticky-directive'
Vue.directive('Sticky', Sticky);

if (process.env.NODE_ENV == 'production'){
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}


// Make Loader and BookingSection component globally available
import Loader from '../shared/loader.vue'
Vue.component('Loader', Loader)

import BookingSection from '../shared/bookingSection.vue'
Vue.component('BookingSection', BookingSection)

import ErrorMessage from '../shared/errorMessage.vue'
Vue.component('ErrorMessage', ErrorMessage)

import BookingElementError from '../shared/bookingElementError.vue'
Vue.component('BookingElementError', BookingElementError)

import TextInput from '../shared/textInput.vue'
Vue.component('TextInput', TextInput)

import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.use(VueLodash, { lodash })

import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: h => h(Booking, {props: {
      productId: window.productId, locale: window.locale }}),
    i18n
  }).$mount('#booking-container')
})